import React, { useEffect } from 'react';
import * as PropTypes from 'prop-types';

export const ConfirmBeforeExit = ( { showConfirmOnClose }: ConfirmBeforeExitProps ) => {
    useEffect(() => {
        if (showConfirmOnClose) {
            // https://developer.mozilla.org/en-US/docs/Web/API/Window/beforeunload_event
            const handleBeforeUnload = e => {
                e.preventDefault();
                // Included for legacy support, e.g. Chrome/Edge < 119
                e.returnValue = true;
            };
            window.addEventListener('beforeunload', handleBeforeUnload);
            return () => {
                window.removeEventListener('beforeunload', handleBeforeUnload);
            };
        } else {
            return () => {};
        }
    }, [showConfirmOnClose]);

    return <></>;
};

export interface ConfirmBeforeExitProps {
    showConfirmOnClose: boolean
}

ConfirmBeforeExit.propTypes = {
    showConfirmOnClose: PropTypes.bool
};
